// PROPOSITO: entrar, salir, y saber quien es quien al abrir la app.
// DEPENDENCIAS: src/lib/supabase, src/store/auth.
// NO OBVIO: el rol y el alumna_id se leen de la BASE, no del token ni de nada que venga del
// navegador. Si vinieran del cliente, bastaria con manipularlos para ver otra pantalla — y aunque
// la RLS igual no devolveria datos, la app mentiria sobre quien eres.

import { supabase } from '@/lib/supabase'
import { usarAuth } from '@/store/auth'
import { INTERRUPTORES } from '@/config/constantes'
import { ALUMNA_DE_DEMOSTRACION, PERFIL_DE_DEMOSTRACION } from '@/services/demo/fixtures'
import type { Perfil } from '@/types/dominio'

interface FilaPerfil {
  id: string
  rol: Perfil['rol']
  nombre: string
  telefono: string | null
  zona_horaria: string
}

async function cargarPerfil(): Promise<void> {
  if (INTERRUPTORES.demo) {
    usarAuth.getState().entrar(PERFIL_DE_DEMOSTRACION, ALUMNA_DE_DEMOSTRACION)
    return
  }

  const { data: sesion } = await supabase.auth.getSession()
  if (!sesion.session) {
    usarAuth.getState().salir()
    return
  }

  const [perfil, alumna] = await Promise.all([
    supabase.from('perfiles').select('id, rol, nombre, telefono, zona_horaria').single(),
    supabase.from('alumnas').select('id').maybeSingle(),
  ])

  if (!perfil.data) {
    usarAuth.getState().salir()
    return
  }

  const fila: FilaPerfil = perfil.data
  usarAuth.getState().entrar(
    {
      id: fila.id,
      rol: fila.rol,
      nombre: fila.nombre,
      telefono: fila.telefono,
      zonaHoraria: fila.zona_horaria,
    },
    alumna.data?.id ?? null,
  )
}

/** Se llama una vez desde main.tsx, antes del primer render. */
export async function arrancarSesion(): Promise<void> {
  await cargarPerfil()
  usarAuth.getState().marcarCargado()
  if (INTERRUPTORES.demo) return
  supabase.auth.onAuthStateChange(() => {
    void cargarPerfil()
  })
}

export async function entrarConCorreo(correo: string, clave: string): Promise<void> {
  const { error } = await supabase.auth.signInWithPassword({ email: correo, password: clave })
  if (error) throw error
  await cargarPerfil()
}

export async function pedirEnlaceDeAcceso(correo: string): Promise<void> {
  const { error } = await supabase.auth.signInWithOtp({ email: correo })
  if (error) throw error
}

export async function salir(): Promise<void> {
  await supabase.auth.signOut()
  usarAuth.getState().salir()
}
